module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../node_modules/ts-loader/index.js??ruleSet[1].rules[2].use[0]!./receipt-processing-centre.ts"));
	}, "views/receipt-processing-centre/receipt-processing-centre");
}